// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap_3xNRa","list":"list_3s7-a","item":"item_2JPHY","term":"term_1ZNuA","figure":"figure_EjJz1"};